export default __webpack_public_path__ + "static/6-9aa2f4aaf73bab01f9caf60bff25e296.jpeg";